import {
  ActivationRequiredWarning,
  QuickTable,
  QuickTableFilterTabs,
} from "../../components";
import { fraudsAndRisksDisplayFormatter } from "./fraudsAndRisksDisplayFormatter";
import { IFraudsAndRisksViewProps } from "./FraudsAndRisks";

export const View = (props: IFraudsAndRisksViewProps) => {
  return (
    <>
      <ActivationRequiredWarning
        title="You still have some work to do..."
        subtitle="Activating your profile will enable better security and fraud checks. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <QuickTable
        id="fraudsAndRisksTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        renderDetail={(item) => item.description}
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={fraudsAndRisksDisplayFormatter}
        onExport={props.onExport}
      />
    </>
  );
};
